<template>
  <div class="dialogPar">
    <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '1'">
      <car-form :formItem="car"></car-form>
    </el-form>

    <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2' && typeOfpar2 === '1'">
      <carcopy-form :formItem="car_copy"></carcopy-form>
    </el-form>

    <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2' && typeOfpar2 === '2'">
      <two-wheel-form :formItem="twoWheel"></two-wheel-form>
    </el-form>

    <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2' && typeOfpar2 === '3'">
      <person-form :formItem="person"></person-form>
    </el-form>
  </div>
</template>

<script>
  import bus from './bus'
  import arrayData from '../assets/javascript/dataProcess'
  import carForm from '../assets/components/form'
  import carcopyForm from '../assets/components/form'
  import twoWheelForm from '../assets/components/form'
  import personForm from '../assets/components/form'
  export default {
    name: "dialogPar",
    components:{
      carForm,
      twoWheelForm,
      personForm,
      carcopyForm
    },
    data() {
      return {
        /*是否可以编辑*/
        disabled:true,
        /*参与方二的种类*/
        typeOfpar2:'1',
        /*参与方的编号*/
        parType:'1',
        car:[],
        car_copy:[],
        twoWheel:[],
        person:[]
      }
    },
  methods:{
    /*数据渲染*/
    dataRender(){
      let carList = this.parData.carList;
      let twoWheel = this.parData.twoWheelVehicleList;
      let personList = this.parData.personList;
      if(carList.length > 1){
        this.typeOfpar2 = '1';
        for(let i = 0;i < this.car.length;i++){
          for (let key of Object.keys(carList[0])) {
            if(key === this.car[i].name){
              this.car[i].value = carList[0][key];
            }
          }
        }
        for(let i = 0;i < this.car_copy.length;i++){
          for (let key of Object.keys(carList[1])) {
            if(key === this.car_copy[i].name){
              this.car_copy[i].value = carList[1][key];
            }
          }
        }
      }
      else {
        for(let i = 0;i < this.car.length;i++){
          for (let key of Object.keys(carList[0])) {
            if(key === this.car[i].name){
              this.car[i].value = carList[0][key];
            }
          }
        }
        if(twoWheel.length > 0){
          this.typeOfpar2 = '2';
          for(let i = 0;i < this.twoWheel.length;i++){
            for (let key of Object.keys(twoWheel[0])) {
              if(key === this.twoWheel[i].name){
                this.twoWheel[i].value = twoWheel[0][key];
              }
            }
          }
        }
        if(personList.length > 0){
          this.typeOfpar2 = '3';
          for(let i = 0;i < this.person.length;i++){
            for (let key of Object.keys(personList[0])) {
              if(key === this.person[i].name){
                this.person[i].value = personList[0][key];
              }
            }
          }
        }
      }
    }
  },
    created(){
      this.car = arrayData.data2.car;
      this.car_copy = arrayData.data2.car_copy;
      this.person = arrayData.data2.person;
      this.twoWheel = arrayData.data2.twoWheel;
      /*接收参与方编号*/
      bus.$on("parType",msg=>{
        this.parType = msg;
      });
      /*接收是否可以编辑*/
      bus.$on("change",()=>{
        this.disabled=false;
      });
      /*接收数据*/
      bus.$on("par",msg=>{
        this.parData = msg;
        this.dataRender();
      });
      /*接收案例编号*/
      bus.$on("caseNumber",msg=>{
        this.car[0].value = msg;
        this.car_copy[0].value = msg;
        this.person[0].value = msg;
        this.twoWheel[0].value = msg;
      })
    }
  }
</script>

<style scoped>
  .dialogPar{
    width: 99%;
    height: 100%;
  }
  .formMsg{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content:flex-start;
  }

</style>

<style>
  .dialogPar .el-form-item__label{
    font-size: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/exportData/dialogPar.vue